var selectVisiblePage = function () { return function (state) {
    var result = Object.entries(state.visibilePage).reduce(function (a, b) { return (a[1] > b[1] ? a : b); })[0];
    return result;
}; };
export default selectVisiblePage;
